export const resources = [
  { url: require("./img/s1-bg.jpg"), name: "s1-bg" },
  { url: require("./img/s1-coffee.png"), name: "s1-coffee" },
  { url: require("./img/s1-loading.png"), name: "s1-loading" },
  { url: require("./img/s1-steam1.png"), name: "s1-steam1" },
  { url: require("./img/s1-steam2.png"), name: "s1-steam2" },
  { url: require("./img/s1-title.png"), name: "s1-title" },
  { url: require("./img/s10-bg.jpg"), name: "s10-bg" },
  { url: require("./img/s10-dialog.png"), name: "s10-dialog" },
  { url: require("./img/s10-person.png"), name: "s10-person" },
  { url: require("./img/s10-pot.png"), name: "s10-pot" },
  { url: require("./img/s11-bg.jpg"), name: "s11-bg" },
  { url: require("./img/s11-hour.png"), name: "s11-hour" },
  { url: require("./img/s11-min.png"), name: "s11-min" },
  { url: require("./img/s11-txt1.png"), name: "s11-txt1" },
  { url: require("./img/s11-txt2.png"), name: "s11-txt2" },
  { url: require("./img/s11-txt3.png"), name: "s11-txt3" },
  { url: require("./img/s11-txt4.png"), name: "s11-txt4" },
  { url: require("./img/s11-txt5.png"), name: "s11-txt5" },
  { url: require("./img/s11-txt6.png"), name: "s11-txt6" },
  { url: require("./img/s11-txt7.png"), name: "s11-txt7" },
  { url: require("./img/s12-bg.jpg"), name: "s12-bg" },
  { url: require("./img/s12-dialog.png"), name: "s12-dialog" },
  { url: require("./img/s13-bg.jpg"), name: "s13-bg" },
  { url: require("./img/s13-qr.png"), name: "s13-qr" },
  { url: require("./img/s13-slogan.png"), name: "s13-slogan" },
  { url: require("./img/s13-txt1.png"), name: "s13-txt1" },
  {url: require('./img/s13-face1.png'), name: 's13-face1'},
  {url: require('./img/s13-face2.png'), name: 's13-face2'},
  {url: require('./img/s13-face3.png'), name: 's13-face3'},
  { url: require("./img/s2-arrows.png"), name: "s2-arrows" },
  { url: require("./img/s2-bg.jpg"), name: "s2-bg" },
  { url: require("./img/s2-calendar.png"), name: "s2-calendar" },
  { url: require("./img/s2-coffee-steam1.png"), name: "s2-coffee-steam1" },
  { url: require("./img/s2-coffee-steam2.png"), name: "s2-coffee-steam2" },
  { url: require("./img/s2-coffee.png"), name: "s2-coffee" },
  { url: require("./img/s2-computer.png"), name: "s2-computer" },
  { url: require("./img/s2-dialog.png"), name: "s2-dialog" },
  { url: require("./img/s2-keyboard.png"), name: "s2-keyboard" },
  { url: require("./img/s2-leaf.png"), name: "s2-leaf" },
  { url: require("./img/s2-notes.png"), name: "s2-notes" },
  { url: require("./img/s2-rabbits.png"), name: "s2-rabbits" },
  { url: require("./img/s3-bg.jpg"), name: "s3-bg" },
  { url: require("./img/s3-breeze1.png"), name: "s3-breeze1" },
  { url: require("./img/s3-breeze2.png"), name: "s3-breeze2" },
  { url: require("./img/s3-dialog1.png"), name: "s3-dialog1" },
  { url: require("./img/s3-dialog2.png"), name: "s3-dialog2" },
  { url: require("./img/s3-dialog3.png"), name: "s3-dialog3" },
  { url: require("./img/s3-dialog4.png"), name: "s3-dialog4" },
  { url: require("./img/s3-hand.png"), name: "s3-hand" },
  { url: require("./img/s3-leaf1.png"), name: "s3-leaf1" },
  { url: require("./img/s3-leaf2.png"), name: "s3-leaf2" },
  { url: require("./img/s3-mouth1.png"), name: "s3-mouth1" },
  { url: require("./img/s3-mouth2.png"), name: "s3-mouth2" },
  { url: require("./img/s3-mouth3.png"), name: "s3-mouth3" },
  { url: require("./img/s3-mouth4.png"), name: "s3-mouth4" },
  { url: require("./img/s3-person.png"), name: "s3-person" },
  { url: require("./img/s3-rabbit1.png"), name: "s3-rabbit1" },
  { url: require("./img/s3-rabbit2.png"), name: "s3-rabbit2" },
  { url: require("./img/s3-rabbit3.png"), name: "s3-rabbit3" },
  { url: require("./img/s3-sound.png"), name: "s3-sound" },
  { url: require("./img/s4-bg.jpg"), name: "s4-bg" },
  { url: require("./img/s4-dialog.png"), name: "s4-dialog" },
  { url: require("./img/s4-hour.png"), name: "s4-hour" },
  { url: require("./img/s4-min.png"), name: "s4-min" },
  { url: require("./img/s4-pop.png"), name: "s4-pop" },
  { url: require("./img/s5-bg.jpg"), name: "s5-bg" },
  { url: require("./img/s5-dialog.png"), name: "s5-dialog" },
  { url: require("./img/s5-left-hand1.png"), name: "s5-left-hand1" },
  { url: require("./img/s5-left-hand2.png"), name: "s5-left-hand2" },
  { url: require("./img/s5-para.png"), name: "s5-para" },
  { url: require("./img/s5-rabbit.png"), name: "s5-rabbit" },
  { url: require("./img/s5-right-hand.png"), name: "s5-right-hand" },
  { url: require("./img/s6-bg.jpg"), name: "s6-bg" },
  { url: require("./img/s6-bulb.png"), name: "s6-bulb" },
  { url: require("./img/s6-dialog1.png"), name: "s6-dialog1" },
  { url: require("./img/s6-dialog2.png"), name: "s6-dialog2" },
  { url: require("./img/s6-dialog3.png"), name: "s6-dialog3" },
  { url: require("./img/s6-dialog4.png"), name: "s6-dialog4" },
  { url: require("./img/s7-bg.jpg"), name: "s7-bg" },
  { url: require("./img/s7-dialog.png"), name: "s7-dialog" },
  { url: require("./img/s7-q1.png"), name: "s7-q1" },
  { url: require("./img/s7-q2.png"), name: "s7-q2" },
  { url: require("./img/s7-q3.png"), name: "s7-q3" },
  { url: require("./img/s7-q4.png"), name: "s7-q4" },
  { url: require("./img/s8-bg.jpg"), name: "s8-bg" },
  { url: require("./img/s8-qa1.png"), name: "s8-qa1" },
  { url: require("./img/s8-qa2.png"), name: "s8-qa2" },
  { url: require("./img/s8-qa3.png"), name: "s8-qa3" },
  { url: require("./img/s8-qb1.png"), name: "s8-qb1" },
  { url: require("./img/s8-qb2.png"), name: "s8-qb2" },
  { url: require("./img/s8-qb3.png"), name: "s8-qb3" },
  { url: require("./img/s9-bg.jpg"), name: "s9-bg" },
  { url: require("./img/s9-dialog1.png"), name: "s9-dialog1" },
  { url: require("./img/s9-dialog2.png"), name: "s9-dialog2" },
  { url: require("./img/s9-dialog3.png"), name: "s9-dialog3" }
];
